export default "__VITE_ASSET__CvznXYV8__"